/* DeviceRestoreViewRenderer.js */

"use strict";
// require("@gluenetworks/jstree");
const _ = require("lodash");
const formatters = require("./cellFormaters");

const RestoreDetailComponent = require("./veils/restoredetail/RestoreDetailComponent");
const RestoreSummaryComponent = require("./veils/restoresummary/RestoreSummaryComponent");

/* global Slick */

class DeviceRestoreViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("device-restore-view-gl");
        this._rootElem.classList.add("device-restore-view-gl");
        this._rootElem.component = this._model;
        this._logger = this._model.logger;
        this._rootElem.appendChild(this._createNoDataPlaceholder(null, true));
        this._model._gameEditor.renderer.rootElement.classList.add("device-backups-view");
        this._rootElem.classList.add("empty");
        this._sortArg;

        this._topContainer = document.createElement("top-container");

        this._countContainer = document.createElement("result-count");
        this._groupContainer = document.createElement("group-dropdown");
        this._templateNameContainer = document.createElement("t-name");
        this._executionTimeContainer = document.createElement("execution-time");

        this._columns = [
            {
                id: "createdOn",
                width: 40,
                name: "Created On",
                field: "createdOn",
                toolTip: "Created On",
                formatter: formatters.dateFormatter,
                sortable: true,
            },
            {
                id: "name",
                width: 60,
                name: "Name",
                field: "name",
                toolTip: "Name",
                sortable: true,
            },
            {
                id: "os",
                width: 40,
                name: "OS",
                field: "os",
                toolTip: "OS",
                sortable: true,
            },
            {
                id: "osVersion",
                width: 30,
                name: "OS Version",
                field: "osVersion",
                toolTip: "OS Version",
                sortable: true,
            },
            {
                id: "serial",
                width: 40,
                name: "Serial",
                field: "serial",
                toolTip: "Serial",
                sortable: true,
            },
            {
                id: "sku",
                width: 40,
                name: "SKU",
                field: "sku",
                toolTip: "SKU",
                sortable: true,
            },
            {
                id: "createdBy",
                width: 40,
                name: "Created By",
                field: "createdBy",
                toolTip: "Created By",
                sortable: true,
            },
            {
                id: "size",
                width: 20,
                name: "Size",
                field: "size",
                toolTip: "Size",
                formatter: formatters.sizeFormatter,
                sortable: true,
            },
            {
                id: "checksum",
                width: 70,
                name: "Checksum",
                field: "checksum",
                toolTip: "Checksum",
                formatter: formatters.checksumFormatter,
                // sortable: true,
            },
            {
                id: "action_col",
                width: 20,
                name: "Actions",
                field: "actions",
                toolTip: "Actions",
                formatter: formatters.actionIconsFormatter,
                cssClass: "action-column",
                headerCssClass: "action-column",
                sortable: false,
            },
        ];

        // this._columns = undefined;

        this._slickTableContainer = document.createElement("report-table");
        this._slickTable = undefined;

        this._tableOptions = {
            editable: false,
            enableTextSelectionOnCells: true,
            enableCellNavigation: true,
            enableAsyncPostRender: false,
            forceFitColumns: true,
            autoHeight: false,
            autoEdit: false,
            resizable: true,
            rowHeight: 30,
            enableColumnReorder: false,
        };

        this._onRowCountChange = this._onRowCountChange.bind(this);
        this._slickSort = this._slickSort.bind(this);
        this._onRestoreProgress = this._onRestoreProgress.bind(this);

        this._onWindowResized = _.debounce(this._onWindowResized.bind(this), 300);
        this._backupsUpdated = this._backupsUpdated.bind(this);
        // initiate observer
        this._resObserver = this.observeResize();
        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._model.on("SizeChanged", this._onWindowResized);
        this._model._gameEditor.on("BackupsUpdated", this._backupsUpdated);
        this._model._gameEditor.on("RestoreProgressUpdate", this._onRestoreProgress);
        window.addEventListener("resize", this._onWindowResized);
    }

    _unregisterListeners() {
        this._model._gameEditor.removeAllListeners("RestoreProgressUpdate");
        this._model.removeAllListeners("SizeChanged");
        window.removeEventListener("resize", this._onWindowResized);
        this._model._gameEditor.removeAllListeners("BackupsUpdated");
    }

    _registerSlickListeners() {
        this._unregisterSlickListeners();
        if (this._slickTable) {
            this._slickDataVIew.onRowCountChanged.subscribe(this._onRowCountChange);
            this._slickTable.onCellChange.subscribe(this._onCellChange);
            this._slickTable.onClick.subscribe(
                (this._onSlickClick = this._onSlickClick.bind(this))
            );
            this._slickTable.onSelectedRowsChanged.subscribe(
                (this._onSlickSelectedRowsChanged = this._onSlickSelectedRowsChanged.bind(this))
            );
            this._slickTable.onBeforeEditCell.subscribe(this._onBeforeEditCell);
            this._slickTable.onSort.subscribe(this._slickSort);
        }
    }

    _unregisterSlickListeners() {
        if (this._slickTable) {
            this._slickDataVIew.onRowCountChanged.unsubscribe(this._onRowCountChange);
            this._slickTable.onCellChange.unsubscribe(this._onCellChange);
            this._slickTable.onClick.unsubscribe(this._onSlickClick);
            this._slickTable.onSelectedRowsChanged.unsubscribe(this._onSlickSelectedRowsChanged);
            this._slickTable.onBeforeEditCell.unsubscribe(this._onBeforeEditCell);
            this._slickTable.onSort.unsubscribe(this._slickSort);
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        this._unregisterSlickListeners();
        if (this._slickTable && document.querySelector(".device-restore-view-gl")) {
            this._resObserver.unobserve(document.querySelector(".device-restore-view-gl"));
        }
        let promArr = [];

        return Promise.all(promArr).then(
            () => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
                this._slickTable = undefined;
                this._sortArg = undefined;
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "DataExplorerResultsViewRenderer.shutdown() error."
                );
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        return this._model.whenModelIsReady().then(
            () => {
                if (this._model._backupsFeed && this._model._backupsFeed.length > 0) {
                    this._rootElem.innerHTML = "";
                    this._slickDataVIew = new Slick.Data.DataView();
                    return this._renderSLickLoading()
                        .then(() => {
                            return this._renderResults();
                        })
                        .then(() => {
                            if (this._model._backupConfigId) {
                                const selectedRowIdx = this._slickDataVIew.getIdxById(
                                    this._model._backupConfigId
                                );
                                this._selectRow(selectedRowIdx);
                            }

                            this._resObserver.observe(
                                document.querySelector(".device-restore-view-gl")
                            );
                            return this._model._modalUserFeedback.hideDisplayed();
                        });
                } else {
                    this._rootElem.innerHTML = "";
                    this._rootElem.appendChild(
                        this._createNoDataPlaceholder("No backups available")
                    );
                }
                return Promise.resolve();
            },
            (err) => err
        );
    }

    _selectRow(rowIndex) {
        const item = this._slickDataVIew.getItemByIdx(rowIndex);
        const itemId = item.id;

        const row = this._slickDataVIew.getRowById(itemId);

        this._slickTable.setActiveCell(row, 0);
        this._slickTable.setSelectedRows([row]);

        const selectedRow = this._slickTableContainer.querySelector(".slick-row.active");
        if (selectedRow) {
            selectedRow.classList.add("selected");
        }

        this._slickTable.scrollRowIntoView(row);
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE ACTION METHODS            */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE ACTION METHODS              */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    _renderProgress() {
        return this._model._templateEntity.loadRelatedExecutions().then((executions) => {
            this._model._execution = executions[0];
            return this._model._execution.loadRelatedWork();
        });
    }

    _renderSLickLoading() {
        const veil = this._model._modalUserFeedback.displayLoading({
            message: "Generating backups list... ",
        });
        return veil;
    }

    _renderResults() {
        return Promise.resolve().then(() => {
            const groupLabel = document.createElement("label");
            groupLabel.classList.add("bold");
            groupLabel.innerHTML = "Group by: ";
            this._groupContainer.innerHTML = "";
            this._topContainer.appendChild(this._groupContainer);
            this._topContainer.appendChild(this._templateNameContainer);
            this._topContainer.appendChild(this._executionTimeContainer);

            // this._rootElem.appendChild(this._topContainer);
            this._rootElem.appendChild(this._slickTableContainer);

            const _windowWidth = window.innerWidth;
            const _columnWidth = this._columns.length * 180;

            if (_columnWidth < _windowWidth) {
                this._tableOptions.forceFitColumns = true;
            }
            // Unregistering slick listeners before initializing to remove dangling listeners
            this._unregisterSlickListeners();
            this._slickDataVIew.setItems(this._model._slickData);
            this._slickTable = new Slick.Grid(
                this._slickTableContainer,
                this._slickDataVIew,
                this._columns,
                this._tableOptions
            );
            this._slickTable.setSelectionModel(new Slick.RowSelectionModel());
            // console.timeEnd("Slick");
            this._registerSlickListeners();
            const createdOnEl = document.querySelector(".slick-header-column[title='Created On']");
            createdOnEl.click(); // click to display the sort arrow
            createdOnEl.click(); // twice for descending
            return Promise.resolve();
        });
    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onRowCountChange(e, {current}) {
        // console.time("Row Count");
        this._slickTable.invalidateAllRows();
        this._slickTable.resizeCanvas();
        this._toggleNoDataPlaceholder(!current);
        const selectedRow = this._slickTableContainer.querySelector(".slick-row.active");
        if (selectedRow) {
            selectedRow.classList.add("selected");
        }
        // console.timeEnd("Row Count");
    }

    _slickSort(e, args) {
        if (!args) {
            args = this._sortArg;
        } else {
            this._sortArg = args;
        }
        // console.time("Sort");
        // console.time("Sort logic");
        this._slickDataVIew.sort((a, b) => {
            let x = a[args.sortCol.field],
                y = b[args.sortCol.field];
            if (x === null || x === undefined) {
                x = args.sortCol.type === "number" ? 0 : "";
            }
            if (y === null || y === undefined) {
                y = args.sortCol.type === "number" ? 0 : "";
            }
            if (typeof x === "number" && typeof y === "number") {
                return x - y;
            } else {
                if (typeof x === "string") {
                    x = x.toLowerCase();
                }
                if (typeof y === "string") {
                    y = y.toLowerCase();
                }
                return x === y ? 0 : x > y ? 1 : -1;
            }
        }, args.sortAsc);
        // console.timeEnd("Sort logic");
        // console.time("Sort render");
        this._slickTable.invalidate();
        this._slickTable.render();
        // console.timeEnd("Sort render");
        // console.timeEnd("Sort");
    }
    _onSlickClick(e, args) {
        const {cell, row, grid} = args;
        const cellid = grid.getColumns()[cell].id;
        const iconEl = e.target.closest("actionable-icon-gl");
        if (cellid === "action_col" && iconEl) {
            const configId = iconEl.dataset.configId;
            const _role = iconEl.dataset.role;
            switch (_role) {
                case "delete":
                    this._deleteDeviceConfigBackup(configId);
                    break;
                case "run":
                    this._restoreDevice(configId);
                    break;
                case "snapshot":
                    const snapshotId = iconEl.dataset.snapshotId;
                    this._openSnapshotView(snapshotId);
                    break;
                default:
                    break;
            }
        }
        const cellNode = grid.getCellNode(row, 1);
        cellNode.closest(".grid-canvas").find(".slick-row").removeClass("selected");
        cellNode.closest(".slick-row").addClass("selected");
    }

    async _deleteDeviceConfigBackup(configId) {
        const currentEntity = this._model._backupsFeed.find((i) => i.getId() === configId),
            name = currentEntity.getDescription();
        try {
            await this.model._modalUserFeedback.displayConfirmation(
                `Are you sure you want to delete the backup "${name}"?\n`,
                {
                    title: "Delete Confirmation",
                    confirmDetails: {
                        text: "Delete",
                        type: "destructive",
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text",
                    },
                }
            );

            await currentEntity.runDeleteDeviceBackupConfigurationWork();
            await this._model.whenModelIsReady();
            this._reRenderGrid();
            this.model._modalUserFeedback.hideDisplayed();
        } catch (err) {
            this._logger.warn(
                {error: err},
                "DeviceRestoreViewRenderer._deleteDeviceConfigBackup()"
            );
        }
    }

    _reRenderGrid() {
        if (this._model._backupsFeed && this._model._backupsFeed.length > 0) {
            this._slickDataVIew.setItems(this._model._slickData);
            this._slickTable.invalidate();
            this._slickTable.render();
            this._slickSort();
        } else {
            if (this._slickTable) {
                this._unregisterSlickListeners();
                this._slickTable = undefined;
                this._rootElem.innerHTML = "";
                this._rootElem.appendChild(this._createNoDataPlaceholder("No backups available"));
            }
        }
    }

    _openSnapshotView(id) {
        this._model._gameEditor.setActiveView(
            "App.GameConsole.Section.GameCenter.Editors.DeviceInstanceEditor.Views.Config",
            [],
            {selectedConfigId: id}
        );
    }

    async _restoreDevice(configId) {
        const currentEntity = this._model._backupsFeed.find((i) => i.getId() === configId),
            name = currentEntity.getDescription();

        if (currentEntity.detectedOs !== this._model._device.detectedOs) {
            return this._model._modalUserFeedback.displayError({
                errorMsg: `The backup ${currentEntity.description} was saved from an OS that does not match your current device's OS.
                    This Backup cannot be restored.`,
                errorCode: "RestoreError",
                title: "Restore Error",
            });
        }

        try {
            let hasWarning = false;
            let msg = "";
            if (
                currentEntity.detectedSoftwareVersion !==
                this._model._device.detectedSoftwareVersion
            ) {
                hasWarning = true;
                msg = `The backup ${name} was saved from an OS version ${
                    currentEntity.detectedSoftwareVersion
                        ? "(" + currentEntity.detectedSoftwareVersion + ") "
                        : ""
                }that does not match your current device's OS version (${
                    this._model._device.detectedSoftwareVersion
                }). Restoring this backup may lead to compatibility issues. Are you sure you want to restore this backup?`;
            } else if (currentEntity.detectedSku !== this._model._device.detectedSku) {
                hasWarning = true;
                msg = `The backup ${name} was saved from a SKU ${
                    currentEntity.detectedSku ? "(" + currentEntity.detectedSku + ") " : ""
                } that does not match your current device's SKU (${
                    this._model._device.detectedSku
                }). Restoring this backup may lead to compatibility issues. Are you sure you want to restore this backup?`;
            } else if (
                currentEntity.detectedSerialNumber !== this._model._device.detectedSerialNumber
            ) {
                hasWarning = true;
                msg = `The backup ${name} was saved from a device with serial number ${
                    currentEntity.detectedSerialNumber
                        ? '"' + currentEntity.detectedSerialNumber + '" '
                        : ""
                }that does not match the current device serial number "${
                    this._model._device.detectedSerialNumber
                }". Restoring this backup may lead to compatibility issues. Are you sure you want to restore this backup?`;
            }

            if (hasWarning) {
                await this._model._modalUserFeedback.displayConfirmation(msg, {
                    title: "Restore",
                    confirmDetails: {
                        text: "Confirm",
                        type: "text",
                    },
                    rejectDetails: {
                        text: "Cancel",
                        type: "text",
                    },
                });
            }
            await this._model._modalUserFeedback.hideDisplayed();
            const opts = await this._model._modalUserFeedback.displayCustom(
                new RestoreDetailComponent(this._logger, this, currentEntity, this._model._device),
                {dontHide: true}
            );

            const _progressCallBack = () => {
                // console.log("status", args);
                // // const msg = `Succeeded ${successCount}, failed ${failureCount} of ${targetCount} devices`;
                // this._progressComponent.emit("progress", workId || "", Math.random()*100);
            };

            const workInput = {
                postCapture: opts.postCapture,
                defaultSnapshot: opts.defaultSnapshot,
                restoreCommands: this._model._device.restoreCommands || [],
                deviceBackup: {},
            };
            workInput.deviceBackup[this._model._device.id] = currentEntity.getId();
            this._model._modalUserFeedback.displayLoading({
                message: "Restoring device...",
                showHideButton: true,
            });
            const res = await this._model._device.runRestoreWork(
                workInput,
                {launchAndForget: false},
                _progressCallBack
            );
            if (!this._model._modalUserFeedback.isStillOpen) {
                return;
            }
            await this._model._modalUserFeedback.displayCustom(
                new RestoreSummaryComponent(res, this._logger)
            );
        } catch (err) {
            this._model._modalUserFeedback.hideDisplayed();
            this._logger.warn(err);
        }
    }

    _onSlickSelectedRowsChanged(/*evt, {rows, grid}*/) {
        // console.log("sel", evt, rows, grid);
    }

    _onWindowResized() {
        this._slickTable.resizeCanvas();
        const selectedRow = this._slickTableContainer.querySelector(".slick-row.active");
        if (selectedRow) {
            selectedRow.classList.add("selected");
        }
    }

    _backupsUpdated() {
        this._model.whenModelIsReady().then(() => {
            this._reRenderGrid();
        });
    }
    _onRestoreProgress(val) {
        this._model._modalUserFeedback.showLoadingProgress(val);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _getDateTime(val) {
        const date = new Date(val);
        return `${date.toLocaleDateString()}, ${date.toLocaleTimeString()}`;
    }

    _createNoDataPlaceholder(msg, veil = false) {
        const noDataPlaceholder = document.createElement("div");
        noDataPlaceholder.classList.add("no-data-placeholder");
        if (veil) {
            noDataPlaceholder.classList.add("dark");
        }
        noDataPlaceholder.innerText = msg || "Initializing restore view...";
        return noDataPlaceholder;
    }

    _toggleNoDataPlaceholder(state) {
        this._rootElem.classList.toggle("empty", state);
        this._rootElem.appendChild(this._createNoDataPlaceholder(null, true));
    }

    // Resize observer

    observeResize() {
        const resObs = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.contentRect && this._model) {
                    this._model.emit("SizeChanged");
                }
            });
        });
        return resObs;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = DeviceRestoreViewRenderer;
